const events = require("./sectionEvents.js");

function surveyWithUpdatedSection(survey, pageID, sectionID, sectionUpdate) {
    const page = survey.Pages.find(p => p.GUID === pageID);
    const pageIndex = survey.Pages.indexOf(page);

    const section = page.Sections.find(s => s.GUID === sectionID);
    const sectionIndex = page.Sections.indexOf(section);

    const updatedSection = Object.assign({}, section, sectionUpdate);

    const updatedPage = Object.assign({}, page, {
        Sections: [
            ...page.Sections.slice(0, sectionIndex),
            updatedSection,
            ...page.Sections.slice(sectionIndex +1)
        ]
    });

    const surveyUpdate = Object.assign({}, survey, {
        Pages: [
        ...survey.Pages.slice(0, pageIndex),
        updatedPage,
        ...survey.Pages.slice(pageIndex +1)
        ]
    });

    return surveyUpdate;
}

function getCurrentQuestionSnapshot(survey) {
    const page = survey.Pages.find(p => p.GUID === survey.CurrentPageGUID);
    const section = page.Sections.find(s => s.GUID === survey.CurrentSectionGUID);

    return JSON.parse(JSON.stringify(section.Questions));
}

const sectionHandlers = {
    [events.UpdateQuestions.Name](prev, event) {
        const currentSurveyUpdate = surveyWithUpdatedSection(
            prev.CurrentSurvey,
            event.PageID,
            event.SectionID,
            {
                Questions: event.Questions
            });
                
        const result = Object.assign({}, prev, {
            CurrentSurvey: currentSurveyUpdate
        });

        return result;
    },
    [events.Saving.Name](prev, event) {
        const currentSurveyUpdate = surveyWithUpdatedSection(
            prev.CurrentSurvey,
            event.PageID,
            event.SectionID,
            {
                IsSaving: true,
                SaveError: null
            });

        const result = Object.assign({}, prev, {
            CurrentSurvey: currentSurveyUpdate,
            IsSaving: true
        });

        return result;
    },
    [events.Saved.Name](prev, event) {
        const currentSurveyUpdate = surveyWithUpdatedSection(
            prev.CurrentSurvey,
            event.PageID,
            event.SectionID,
            {
                IsSaving: false,
                SaveError: null
            });

        // Our question snapshot should be updated too (for dirty checking)
        // but only if we're on the same page/section.
        const snapshotUpdate =
            event.PageID === prev.CurrentSurvey.CurrentPageGUID
            && event.SectionID === prev.CurrentSurvey.CurrentSectionGUID
            ? getCurrentQuestionSnapshot(prev.CurrentSurvey)
            : [];

        const withSnapshotUpdate = Object.assign({}, currentSurveyUpdate, {
            CurrentQuestionSnapshot: snapshotUpdate
        });

        const result = Object.assign({}, prev, {
            CurrentSurvey: withSnapshotUpdate,
            IsSaving: false,
            SaveError: null
        });

        return result;
    },
    [events.SaveErrored.Name](prev, event) {
        const currentSurveyUpdate = surveyWithUpdatedSection(
            prev.CurrentSurvey,
            event.PageID,
            event.SectionID,
            {
                IsSaving: false,
                SaveError: event.Error
            });

        const result = Object.assign({}, prev, {
            CurrentSurvey: currentSurveyUpdate,
            IsSaving: false,
            SaveError: event.Error
        });

        return result;
    },
    [events.ClearErrors.Name](prev, event) {
        const currentSurveyUpdate = surveyWithUpdatedSection(
            prev.CurrentSurvey,
            event.PageID,
            event.SectionID,
            {
                SaveError: null
            });

        const result = Object.assign({}, prev, {
            CurrentSurvey: currentSurveyUpdate,
            IsSaving: false,
            SaveError: null
        });

        return result;
    }
};

module.exports = sectionHandlers;


// WEBPACK FOOTER //
// ./src/events/section/sectionHandlers.js